define('plugins/musicfavourite/ui/dialogs/limited-dialog',['./dialog', '../localisation', '../dom', 'exports'], function (Dialog, localisation, DOM, exports) {


    var EVENT_NAME = 'limited',

    MANAGE_LINKS = {
        'radio': {
            'music_guide': '/music/playlister/presenters#plr-presenterslist',
            'music_guide_trunk': '/music/playlister/presenters?v=trunk#plr-presenterslist'
        }
    };


    exports.initialise = function(notifier) {
        notifier.subscribe(EVENT_NAME, function(button) {

            // button.text.dialog - dialog translations from current button profile
            // button.lang - locale setting for current button

            exports.show(button.text.dialog, button.lang, button.item);

        });
    };


    exports.show = function(translations, locale, item) {

        // simplified wrapper for localisation.getLocalisedString
        function getLocalisedString(key) {
            return localisation.getLocalisedString(translations, key, 'limited', locale, '');
        }

        var markup = '<h3 class="' + Dialog.classes.heading + '">' + getLocalisedString('heading') + '</h3>',

        limitHint = getLocalisedString('limitHint'),

        manageLinkText = getLocalisedString('manageLink');

        manageLink = item && item.appId && item.type && MANAGE_LINKS[item.appId] && MANAGE_LINKS[item.appId][item.type];

        if (window.location.href.indexOf('v=trunk') !== -1) {
            manageLink = item && item.appId && item.type && MANAGE_LINKS[item.appId] && MANAGE_LINKS[item.appId][item.type + '_trunk'];
        }

        if (manageLink && manageLinkText) {
            markup += '<p class="' + Dialog.classes.text + '">' + '<a href="' + manageLink + '" class="' + Dialog.classes.manageLink + '">' + manageLinkText + '</a> ' +
            limitHint +
            '</p>';
        }

        Dialog.setContent(markup, function() {
            Dialog.show();
        });
    };


    return exports;

});

